import * as e from "react";
import { forwardRef as o } from "react";
const C = o(function(r, t) {
  return /* @__PURE__ */ e.createElement(
    "svg",
    {
      fill: "none",
      ref: t,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      ...r
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M16.203 12.434C16.203 14.916 14.283 16.941 11.931 16.941C9.58001 16.941 7.67301 14.916 7.67301 12.434C7.67301 9.964 9.56701 7.953 11.918 7.94V9.729L15.288 7.482L11.919 5V6.489C10.346 6.49324 8.83899 7.12177 7.72913 8.23651C6.61928 9.35124 5.99735 10.861 6.00001 12.434C6.00001 15.713 8.65201 18.378 11.93 18.378C13.5062 18.3769 15.0176 17.7504 16.1322 16.6359C17.2469 15.5215 17.8737 14.0102 17.875 12.434H16.203Z",
        fill: "currentColor"
      }
    )
  );
});
export {
  C as Refresh
};
